export default function initModal() {
  const modal = document.getElementById('prepareModal');

  // Use a class-based selector instead of text content filtering
  const modalTriggers = document.querySelectorAll('.prepare-modal-trigger');

  if (!modal || !modalTriggers.length) return;

  // Get the modal content element
  const modalContent = modal.querySelector('.modal-content') || modal.firstElementChild;

  // Import Motion dynamically to avoid blocking page load
  import('motion').then(({ animate }) => {
    if (!modalContent) return;

    // Initially set the modal content to be translated down
    modalContent.style.opacity = '0';
    modalContent.style.transform = 'translateY(20px)';

    modalTriggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        modal.classList.remove('hidden');
        document.body.style.overflow = 'hidden';

        // Track modal open event in GA4
        if (window.dataLayer) {
          window.dataLayer.push({
            'event': 'modal_open',
            'modal_trigger': trigger.id || trigger.textContent.trim() || 'unknown'
          });
        }

        // Animate in using Motion
        animate(modalContent,
          { opacity: 1, y: 0 },
          { duration: 0.3, easing: [0.25, 0.1, 0.25, 1] }
        );
      });
    });

    // Helper function for closing animation
    const closeModal = () => {
      // Animate out using Motion
      animate(modalContent,
        { opacity: 0, y: 20 },
        { duration: 0.3, easing: [0.25, 0.1, 0.25, 1] }
      ).finished.then(() => {
        modal.classList.add('hidden');
        document.body.style.overflow = '';
      });
    };

    const modalClose = modal.querySelector('.modal-close');
    if (modalClose) {
      modalClose.addEventListener('click', closeModal);
    }

    // Close modal when clicking outside
    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        closeModal();
      }
    });

    // Close modal with Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !modal.classList.contains('hidden')) {
        closeModal();
      }
    });
  }).catch(error => {
    console.error('Could not load Motion library:', error);
    // Fallback to non-animated behavior if Motion fails to load
  });
}